
























































import { Vue, Component, Prop, Provide } from 'vue-property-decorator'
import { toV } from '@/app/core/utils'
import { DiscountsMixin } from '@shared/mixins/discounts'
import ProductItem from '@pages/search/components/common/product_item.vue'

@Component({
  components: {
    ProductItem,
  },
  filters: {
    distanceStr(distance: string) {
      return +distance > 60 ? '>60' : distance
    },
  },
})
export default class GoodsComponent extends DiscountsMixin {
  @Prop({ type: Boolean, default: false }) readonly showEntity!: boolean
  @Prop({ type: Boolean, default: false }) readonly showEmpty!: boolean
  @Prop({ type: Array, default: [] }) readonly list!: any[]

  @Provide()
  pageTrackParams: any = {}
  @Provide()
  clickid_200005 = ''
  @Provide()
  clickid_home_product = ''

  // toDetail(item: any) {
  //   const { spuId, businessId } = item
  //   //const { seckill } = this.seekPromotion(item)
  //   //const query: any = seckill ? { skuId: seckill.skuId, ruleId: seckill.ruleId, ruleType: 3 } : {}
  //   toV({
  //     name: 'product-detail',
  //     params: { spuId },
  //     query: { refresh: 'no', businessId },
  //   })
  // }

  // proClass(item: any) {
  //   return this.seekPromotion(item)
  // }

  // getPrice(item: any) {
  //   const promotion = this.seekPromotion(item)
  //   if (promotion.seckill) {
  //     return promotion.seckill.promotionPrice
  //   } else if (promotion.group) {
  //     return promotion.group.promotionPrice
  //   } else {
  //     return item.minPrice
  //   }
  // }
}
